<app-header *ngIf="ShowNav"></app-header>
<div [ngClass]="{ mainWrapper: ShowNav }" id="main-component">
  <main [@routeAnimations]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
  </main>
</div>
<app-footer *ngIf="showFooter"></app-footer>
